import React from 'react';
import ReactDOM from 'react-dom';
import ReactPixel from 'react-facebook-pixel';
import Container from '@groupefungo/react-apollo.core/app/Container';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import TagManager from 'react-gtm-module';
import muiTheme from './src/styles/mui-theme';
import BookingSystemBody from './src/BookingSystemBody';


function BookingSystemApp() {
  return (
    <Container thm={muiTheme} withAuth={false}>
      <BookingSystemBody />
    </Container>
  );
}

if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging') {
  Sentry.init({
    dsn: 'https://6bdf3a95ef74400184912439e2525163@o481104.ingest.sentry.io/5834174',
    integrations: [
      new Integrations.BrowserTracing(),
    ],
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  });
}

if (process.env.NODE_ENV === 'production') {
  const tagManagerArgs = {
    gtmId: 'GTM-PR7KWKJ',
  };
  TagManager.initialize(tagManagerArgs);
}

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <BookingSystemApp />,
    document.body.appendChild(document.createElement('div')),
  );
});

if (process.env.NODE_ENV === 'production') {
  ReactPixel.init('527878900693629');
  ReactPixel.track('PageView');
}
